import React from 'react';
import AnimatedLoader from '../loadingScreen/AnimatedLoader';

/**
 * LoadingOverlay component - Handles the loading state display
 * Separated from the main View3D component for better modularity
 */
const LoadingOverlay = ({ 
    showLoading, 
    progress, 
    onLoadingComplete 
}) => {
    if (!showLoading) return null;

    return (
        <AnimatedLoader 
            progress={progress}
            onLoadingComplete={onLoadingComplete} 
        />
    );
};

export default LoadingOverlay; 